export default (function () {

    addEventListener("DOMContentLoaded", (event) => {
        // Get data from global variable set in twig
        const mapPinsData = window.customMapPinsData || [];
        const apiKey = "AIzaSyDuKFtXWIyXZaftjcsJF8wnZBZ76TJSnBs";

        let activeMarker = null;
        let mapInstance = null;

        // Close popup function
        function closePopup() {
            const popup = document.getElementById('pin-popup');
            if (!popup) return;

            popup.classList.remove('active');

            // Reset active marker animation
            if (activeMarker) {
                activeMarker.setIcon({
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 20,
                    fillColor: '#BF625D',
                    fillOpacity: 1,
                    strokeColor: '#FFFFFF',
                    strokeWeight: 2
                });
                activeMarker = null;
            }
        }

        const closeBtn = document.getElementById('pin-popup-close-btn');
        if (closeBtn) {
            closeBtn.addEventListener('click', closePopup);
        }

        // Expose closePopup globally for onclick handler
        window.customMapClosePopup = closePopup;

        // Create overlay helper for pixel positioning
        let overlayHelper = null;

        function initOverlayHelper() {
            overlayHelper = new google.maps.OverlayView();
            overlayHelper.draw = function() {};
            overlayHelper.onAdd = function() {};
            overlayHelper.onRemove = function() {};
            overlayHelper.setMap(mapInstance);
        }

        // Show popup at marker position
        function showPopup(marker, pin) {
            closePopup();

            const popup = document.getElementById('pin-popup');
            const mapDiv = document.getElementById('custom-map');

            if (!popup || !mapDiv) return;

            // Wait a bit for overlay to be ready if needed
            if (!overlayHelper || !overlayHelper.getProjection()) {
                setTimeout(() => showPopup(marker, pin), 100);
                return;
            }

            const projection = overlayHelper.getProjection();
            const position = marker.getPosition();
            const point = projection.fromLatLngToContainerPixel(position);

            // Update popup content
            // const titleElem = document.getElementById('popup-title');
            const textElem = document.getElementById('popup-text');

            // if (titleElem) titleElem.textContent = pin.title || '';
            if (textElem) textElem.textContent = pin.text || '';

            // Position popup centered on pin (using translate(-50%, -50%) in CSS)
            popup.style.left = point.x + 'px';
            popup.style.top = point.y + 'px';

            // Show popup
            popup.classList.add('active');

            // Animate marker
            marker.setIcon({
                path: google.maps.SymbolPath.CIRCLE,
                scale: 28,
                fillColor: '#BF625D',
                fillOpacity: 1,
                strokeColor: '#FFFFFF',
                strokeWeight: 2
            });

            activeMarker = marker;

            // Adjust position if popup goes off screen
            setTimeout(() => {
                const popupRect = popup.getBoundingClientRect();
                const mapRect = mapDiv.getBoundingClientRect();

                let newX = point.x;
                let newY = point.y;

                const popupHalfWidth = popupRect.width / 2;
                const popupHalfHeight = popupRect.height / 2;

                // Check if popup extends beyond map bounds and adjust
                if (point.x - popupHalfWidth < 0) {
                    newX = popupHalfWidth + 20;
                }
                if (point.x + popupHalfWidth > mapRect.width) {
                    newX = mapRect.width - popupHalfWidth - 20;
                }
                if (point.y - popupHalfHeight < 0) {
                    newY = popupHalfHeight + 20;
                }
                if (point.y + popupHalfHeight > mapRect.height) {
                    newY = mapRect.height - popupHalfHeight - 20;
                }

                if (newX !== point.x || newY !== point.y) {
                    popup.style.left = newX + 'px';
                    popup.style.top = newY + 'px';
                }
            }, 10);
        }

        // Initialize map when page loads
        function initCustomMap() {
            const mapDiv = document.getElementById('custom-map');
            if (!mapDiv) return;

            // Center the map
            const mapCenter = calculateMapCenter(mapPinsData);

            // Grayscale map styles
            const mapStyles = [
            // Custom branded map styles
                {
                    "elementType": "geometry",
                    "stylers": [{"color": "#FFFFFF"}] // white for land base
                },
                {
                    "elementType": "labels.icon",
                    "stylers": [{"visibility": "off"}]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#5D5D5D"}] // tertiary-d for text
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [{"color": "#FFFFFF"}] // white for text outline
                },
                {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#B0B0B0"}] // tertiary for secondary text
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [{"color": "#F6F6F6"}] // tertiary-l for POIs - subtle
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#5D5D5D"}] // tertiary-d
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [{"color": "#F3E7E7"}] // primary-l for parks - very light
                },
                {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#80272A"}] // primary-d for park labels
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [{"color": "#F6F6F6"}] // tertiary-l for roads - slight contrast
                },
                {
                    "featureType": "road",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#5D5D5D"}] // tertiary-d
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [{"color": "#F6F6F6"}] // tertiary-l
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#5D5D5D"}] // tertiary-d
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [{"color": "#EDC2B3"}] // secondary-l for highways
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#80272A"}] // primary-d for highway text
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#B0B0B0"}] // tertiary for local roads
                },
                {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [{"color": "#F3E7E7"}] // primary-l
                },
                {
                    "featureType": "transit.station",
                    "elementType": "geometry",
                    "stylers": [{"color": "#F3E7E7"}] // primary-l
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [{"color": "#F3E7E7"}] // primary-l for water - very light pink
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#B0B0B0"}] // tertiary for water labels
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.stroke",
                    "stylers": [{"color": "#F3E7E7"}] // primary-l
                }


            //     {
            //         "elementType": "geometry",
            //         "stylers": [{"color": "#F6F6F6"}] // tertiary-l for land
            //     },
            //     {
            //         "elementType": "labels.icon",
            //         "stylers": [{"visibility": "off"}]
            //     },
            //     {
            //         "elementType": "labels.text.fill",
            //         "stylers": [{"color": "#5D5D5D"}] // tertiary-d for text
            //     },
            //     {
            //         "elementType": "labels.text.stroke",
            //         "stylers": [{"color": "#F6F6F6"}] // tertiary-l for text outline
            //     },
            //     {
            //         "featureType": "administrative.land_parcel",
            //         "elementType": "labels.text.fill",
            //         "stylers": [{"color": "#B0B0B0"}] // tertiary for secondary text
            //     },
            //     {
            //         "featureType": "poi",
            //         "elementType": "geometry",
            //         "stylers": [{"color": "#F3E7E7"}] // primary-l for POIs
            //     },
            //     {
            //         "featureType": "poi",
            //         "elementType": "labels.text.fill",
            //         "stylers": [{"color": "#5D5D5D"}] // tertiary-d
            //     },
            //     {
            //         "featureType": "poi.park",
            //         "elementType": "geometry",
            //         "stylers": [{"color": "#EDC2B3"}] // secondary-l for parks
            //     },
            //     {
            //         "featureType": "poi.park",
            //         "elementType": "labels.text.fill",
            //         "stylers": [{"color": "#80272A"}] // primary-d for park labels
            //     },
            //     {
            //         "featureType": "road",
            //         "elementType": "geometry",
            //         "stylers": [{"color": "#ffffff"}] // white roads
            //     },
            //     {
            //         "featureType": "road",
            //         "elementType": "labels.text.fill",
            //         "stylers": [{"color": "#5D5D5D"}] // tertiary-d
            //     },
            //     {
            //         "featureType": "road.arterial",
            //         "elementType": "geometry",
            //         "stylers": [{"color": "#ffffff"}]
            //     },
            //     {
            //         "featureType": "road.arterial",
            //         "elementType": "labels.text.fill",
            //         "stylers": [{"color": "#5D5D5D"}] // tertiary-d
            //     },
            //     {
            //         "featureType": "road.highway",
            //         "elementType": "geometry",
            //         "stylers": [{"color": "#F3E7E7"}] // primary-l for highways
            //     },
            //     {
            //         "featureType": "road.highway",
            //         "elementType": "labels.text.fill",
            //         "stylers": [{"color": "#80272A"}] // primary-d for highway text
            //     },
            //     {
            //         "featureType": "road.local",
            //         "elementType": "labels.text.fill",
            //         "stylers": [{"color": "#B0B0B0"}] // tertiary for local roads
            //     },
            //     {
            //         "featureType": "transit.line",
            //         "elementType": "geometry",
            //         "stylers": [{"color": "#EDC2B3"}] // secondary-l
            //     },
            //     {
            //         "featureType": "transit.station",
            //         "elementType": "geometry",
            //         "stylers": [{"color": "#F3E7E7"}] // primary-l
            //     },
            //     {
            //         "featureType": "water",
            //         "elementType": "geometry",
            //         "stylers": [{"color": "#DF9791"}] // secondary for water
            //     },
            //     {
            //         "featureType": "water",
            //         "elementType": "labels.text.fill",
            //         "stylers": [{"color": "#80272A"}] // primary-d for water labels
            //     },
            //     {
            //         "featureType": "water",
            //         "elementType": "labels.text.stroke",
            //         "stylers": [{"color": "#DF9791"}] // secondary
            //     }



                // {
                //     "elementType": "geometry",
                //     "stylers": [{"color": "#f5f5f5"}]
                // },
                // {
                //     "elementType": "labels.icon",
                //     "stylers": [{"visibility": "off"}]
                // },
                // {
                //     "elementType": "labels.text.fill",
                //     "stylers": [{"color": "#616161"}]
                // },
                // {
                //     "elementType": "labels.text.stroke",
                //     "stylers": [{"color": "#f5f5f5"}]
                // },
                // {
                //     "featureType": "administrative.land_parcel",
                //     "elementType": "labels.text.fill",
                //     "stylers": [{"color": "#bdbdbd"}]
                // },
                // {
                //     "featureType": "poi",
                //     "elementType": "geometry",
                //     "stylers": [{"color": "#eeeeee"}]
                // },
                // {
                //     "featureType": "poi",
                //     "elementType": "labels.text.fill",
                //     "stylers": [{"color": "#757575"}]
                // },
                // {
                //     "featureType": "poi.park",
                //     "elementType": "geometry",
                //     "stylers": [{"color": "#e5e5e5"}]
                // },
                // {
                //     "featureType": "poi.park",
                //     "elementType": "labels.text.fill",
                //     "stylers": [{"color": "#9e9e9e"}]
                // },
                // {
                //     "featureType": "road",
                //     "elementType": "geometry",
                //     "stylers": [{"color": "#ffffff"}]
                // },
                // {
                //     "featureType": "road.arterial",
                //     "elementType": "labels.text.fill",
                //     "stylers": [{"color": "#757575"}]
                // },
                // {
                //     "featureType": "road.highway",
                //     "elementType": "geometry",
                //     "stylers": [{"color": "#dadada"}]
                // },
                // {
                //     "featureType": "road.highway",
                //     "elementType": "labels.text.fill",
                //     "stylers": [{"color": "#616161"}]
                // },
                // {
                //     "featureType": "road.local",
                //     "elementType": "labels.text.fill",
                //     "stylers": [{"color": "#9e9e9e"}]
                // },
                // {
                //     "featureType": "transit.line",
                //     "elementType": "geometry",
                //     "stylers": [{"color": "#e5e5e5"}]
                // },
                // {
                //     "featureType": "transit.station",
                //     "elementType": "geometry",
                //     "stylers": [{"color": "#eeeeee"}]
                // },
                // {
                //     "featureType": "water",
                //     "elementType": "geometry",
                //     "stylers": [{"color": "#c9c9c9"}]
                // },
                // {
                //     "featureType": "water",
                //     "elementType": "labels.text.fill",
                //     "stylers": [{"color": "#9e9e9e"}]
                // }
            ];

            // Create map
            const map = new google.maps.Map(mapDiv, {
                center: mapCenter,
                zoom: 10,
                styles: mapStyles,
                mapTypeControl: false,
                streetViewControl: false
            });

            mapInstance = map;

            // Initialize overlay helper for pixel positioning
            initOverlayHelper();

            // Add markers
            mapPinsData.forEach(pin => {
                if (!pin.lat || !pin.lng) return;

                const marker = new google.maps.Marker({
                    position: {
                        lat: parseFloat(pin.lat),
                        lng: parseFloat(pin.lng)
                    },
                    map: map,
                    title: pin.title,
                    icon: {
                        path: google.maps.SymbolPath.CIRCLE,
                        scale: 20,
                        fillColor: '#BF625D',
                        fillOpacity: 1,
                        strokeColor: '#FFFFFF',
                        strokeWeight: 2
                    }
                });

                // Add click listener
                marker.addListener('click', () => {
                    showPopup(marker, pin);
                });
            });

            // Close popup when clicking on map
            map.addListener('click', closePopup);

            // Close popup when zooming or moving
            map.addListener('zoom_changed', closePopup);
            map.addListener('dragstart', closePopup);

            // Adjust bounds to show all markers
            if (mapPinsData.length > 1) {
                const bounds = new google.maps.LatLngBounds();
                mapPinsData.forEach(pin => {
                    if (pin.lat && pin.lng) {
                        bounds.extend({
                            lat: parseFloat(pin.lat),
                            lng: parseFloat(pin.lng)
                        });
                    }
                });
                map.fitBounds(bounds);

                const listener = google.maps.event.addListener(map, "idle", function() {
                    if (map.getZoom() > 14) map.setZoom(14);
                    google.maps.event.removeListener(listener);
                });
            }
        }

        // Calculate center point from all pins
        function calculateMapCenter(pins) {
            if (!pins || pins.length === 0) {
                return { lat: 46.5, lng: 6.5 };
            }

            let latSum = 0;
            let lngSum = 0;
            let count = 0;

            pins.forEach(pin => {
                if (pin.lat && pin.lng) {
                    latSum += parseFloat(pin.lat);
                    lngSum += parseFloat(pin.lng);
                    count++;
                }
            });

            if (count === 0) {
                return { lat: 46.5, lng: 6.5 };
            }

            return {
                lat: latSum / count,
                lng: lngSum / count
            };
        }

        // Expose initCustomMap globally for Google Maps callback
        window.initCustomMap = initCustomMap;

        // Load Google Maps API and initialize
        if (typeof google === 'undefined') {
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&loading=async&callback=initCustomMap`;
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
        } else {
            initCustomMap();
        }
    });
}());